(() => {
  function toInt(val, fallback = 1) {
    const n = parseInt(val, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function updateQuantityUI(selector) {
    const input = selector.querySelector('[data-quantity-input]');
    const minusBtn = selector.querySelector('[data-quantity-minus]');
    const minusWrapper = selector.querySelector('[data-button-wrapper-minus]');

    if (!input || !minusBtn || !minusWrapper) return;

    const min = toInt(input.getAttribute('min'), 1);
    const qty = toInt(input.value, min);

    const disableMinus = qty <= min;

    // Actual button state
    minusBtn.disabled = disableMinus;
    minusBtn.setAttribute('aria-disabled', disableMinus ? 'true' : 'false');

    // Visual state (your theme uses this class)
    minusWrapper.classList.toggle(
      'quantity-selector__button-wrapper--disabled',
      disableMinus
    );
  }

  function init(selector) {
    if (selector.dataset.qsFixed === '1') return;
    selector.dataset.qsFixed = '1';

    // Update immediately on load
    updateQuantityUI(selector);

    const input = selector.querySelector('[data-quantity-input]');
    if (input) {
      input.addEventListener('input', () => updateQuantityUI(selector));
      input.addEventListener('change', () => updateQuantityUI(selector));
    }

    // After clicking plus/minus, existing theme JS may update the value.
    // We wait one frame and then re-sync the disabled state.
    selector.addEventListener('click', (e) => {
      if (e.target.closest('[data-quantity-plus], [data-quantity-minus]')) {
        requestAnimationFrame(() => updateQuantityUI(selector));
      }
    });
  }

  function boot() {
    document
      .querySelectorAll('[data-quantity-selector]')
      .forEach(init);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // If your cart or product section re-renders via AJAX, this catches new nodes
  const obs = new MutationObserver(() => boot());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
